import React from 'react';

import GatedByGlobalSetup from './GatedByGlobalSetup';
import { ViewAccessWrapper } from '../../components';
import { PLATFORM_PERFORMANCE } from '../../constants/views';

const PlatformPerformanceAccess = () => (
  <ViewAccessWrapper
    viewName={PLATFORM_PERFORMANCE}
    viewComponent={<GatedByGlobalSetup />}
  />
);

export default PlatformPerformanceAccess;
